import classNames from "classnames";

function RadioSelector({
  setSelector,
  selectorValue,
  firstLabel,
  secondLabel,
  thirdLabel,
  vertical = false,
}) {
  return (
    <div className="d-col mt-4">
      <div
        className={classNames({
          "flex flex-col md:flex-row": !vertical,
          "d-col": vertical,
        })}
      >
        <div className="d-row mr-4">
          <label className="inline-flex items-center">
            <input
              autoComplete="off"
              type="radio"
              className="form-radio"
              value="1"
              checked={selectorValue === "1"}
              onClick={(e) => setSelector(e.target.value)}
            />
            <span className="ml-2 text-xs font-inter-regular mt-0.5">
              {firstLabel}
            </span>
          </label>
        </div>

        <div
          className={classNames({
            "d-row": true,
            "my-2 md:my-0": !vertical,
            "mt-2": vertical,
          })}
        >
          <label className="inline-flex items-center">
            <input
              autoComplete="off"
              type="radio"
              className="form-radio"
              value="2"
              checked={selectorValue === "2"}
              onClick={(e) => setSelector(e.target.value)}
            />
            <span className="ml-2 text-xs font-inter-regular mt-0.5">
              {secondLabel}
            </span>
          </label>
        </div>

        {thirdLabel && (
          <div className="d-row">
            <label className="inline-flex items-center">
              <input
                autoComplete="off"
                type="radio"
                className="form-radio"
                value="3"
                checked={selectorValue === "3"}
                onClick={(e) => setSelector(e.target.value)}
              />
              <span className="ml-2 text-xs font-inter-regular mt-0.5">
                {thirdLabel}
              </span>
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
export default RadioSelector;
